import PropTypes from 'prop-types';
import { useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { RenderLogo } from 'src/components/animate/animate-logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname, useRouter } from 'src/routes/hook';
import { Typography, useTheme } from '@mui/material';
import { NavSectionVertical } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavVertical({ openNav, onCloseNav }) {
  const theme = useTheme();
  const router = useRouter();
  const pathname = usePathname();
  const lgUp = useResponsive('up', 'lg');
  const navData = useNavData();

  const handleRedirect = (event) => {
    event.preventDefault();
    router.push('/dashboard');
  };

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {theme.direction === 'rtl' ? (
        <Box sx={{ display: 'flex' }}>
          <Typography variant="h6" sx={{ mt: 3.5, ml: 3, display: 'inline-flex' }}>
            AI
            <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
              .
            </Typography>
            SALESRUSH
          </Typography>
          <RenderLogo sx={{ mt: 3, mb: 1 }} width={30} height={30} href='/dashboard' />
        </Box>
      ) : (
        <Box sx={{ display: 'flex' }} onClick={handleRedirect}>
          <RenderLogo sx={{ mt: 3, ml: 2, mb: 1 }} width={30} height={30} />
          <Typography variant="h6" sx={{ mt: 3.5, display: 'inline-flex' }}>
            SALESRUSH
            <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
              .
            </Typography>
            AI
          </Typography>
        </Box>
      )}
      <NavSectionVertical
        data={navData}
        config={{
          currentRole: 'admin',
        }}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            borderRight: (theme_nv) => `dashed 1px ${theme_nv.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

NavVertical.propTypes = {
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
